/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useRef, useEffect, Suspense } from 'react';
import { View, Text, StyleSheet, Pressable, Image } from 'react-native';
import { Modalize } from 'react-native-modalize';
import { useSelector, useDispatch } from 'react-redux';
import Colors from '~global/Colors';
const WithLocalSvg = React.lazy(() =>
  import('@web-components/common/WithLocalSvg'),
);
import { data as Font } from '~global/Fonts';
import { imageCdn, storeAsyncData } from '~global/helpers';
import { isWeb } from '~global/screens';

const Button = React.lazy(() => import('@web-components/form/Button'));

const ModalAddRegistry = ({ navigation }) => {
  const dispatch = useDispatch();
  const modalizeRef = useRef(null);
  const defaultImage = require('~assets/img/dummy_product.png');
  const isShow = useSelector((state) => state.modal.addRegistry.isShow);
  const data = useSelector((state) => state.modal.addRegistry.data);
  const productData = data && data.productData ? data.productData : '';
  const productAttributes = () => {
    if (
      productData &&
      productData.combinations &&
      productData.combinations.length &&
      productData.combinations[0].attributes
    ) {
      const combinationAttributes =
        data.attributes ?? productData?.combinations[0]?.attributes;
      const name = [];
      for (const i in combinationAttributes) {
        name.push({
          group: i,
          value: combinationAttributes[i].name,
        });
      }
      return name;
    } else {
      return '';
    }
  };

  const coverImageSrc =
    productData && productData.images
      ? productData.images.filter((data) => data.is_cover)[0]
      : null;
  const coverImage =
    coverImageSrc && coverImageSrc.url
      ? imageCdn({
          config: isWeb ? 'w=156' : 'w=100',
          image: coverImageSrc.url,
        })
      : null;

  const closeModal = () => {
    storeAsyncData('@first_baby_registry', false);
    dispatch({ type: 'MODAL/HIDE', modalName: 'addRegistry' });
  };

  const goToRegistry = () => {
    closeModal();
    navigation.current.navigate('BabyRegistryScreen');
  };

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <Modalize
      ref={modalizeRef}
      adjustToContentHeight={true}
      handleStyle={styles.handleStyle}
      modalStyle={styles.modalStyle}
      onClose={closeModal}>
      <Suspense fallback={<></>}>
        <View style={styles.modalContainer}>
          <View style={styles.modalHeader}>
            <Pressable style={styles.modalDismiss} onPress={closeModal}>
              <WithLocalSvg
                key="dismiss"
                width={14}
                height={14}
                asset={require('~assets/img/common/modal-dismiss.svg')}
              />
            </Pressable>
          </View>

          <View style={styles.modalBody}>
            <Text style={styles.textHeader}>
              Hi Moms, kamu sedang menambahkan sebuah produk ke dalam list Baby
              Registry.
            </Text>

            <View style={styles.cardInfoRegistry}>
              <Text
                style={[
                  styles.textContent,
                  { color: Colors.purple4, fontWeight: '700' },
                ]}>
                Apa itu Baby Registry?
              </Text>
              <WithLocalSvg
                style={styles.iconRegistry}
                asset={require('~assets/img/baby-registry/icon-baby-registry.svg')}
              />
              <Text style={[styles.textSmall, { marginTop: 8 }]}>
                Baby registry memungkinkan kamu untuk membuat wishlist kebutuhan
                bayimu dan di share ke teman- temanmu. Dengan begitu, temanmu
                juga akan bisa memberikan kado yang tepat sesuai dengan apa yang
                dibutuhkan.
              </Text>
            </View>

            <View style={styles.separator} />

            <Text style={[styles.textContent, { fontWeight: '600' }]}>
              1 Produk berhasil ditambahkan ke dalam Registry. Lihat isi
              registry kamu dan customize sesuai kebutuhanmu.
            </Text>

            <View style={styles.cardProductRegistry}>
              <View>
                <Image
                  source={coverImage ? coverImage : null}
                  style={styles.productImage}
                  resizeMode="cover"
                  defaultSource={defaultImage}
                />
              </View>
              <View style={styles.containerProductInfo}>
                <Text
                  style={[
                    styles.text,
                    { color: Colors.purple4, fontWeight: '600' },
                  ]}>
                  {productData?.brand?.name}
                </Text>
                <Text style={[styles.text, { fontWeight: '600' }]}>
                  {productData?.name}
                </Text>
                <Text style={[styles.textSmall, { color: Colors.grey2 }]}>
                  {productAttributes() &&
                    productAttributes()
                      .filter((item) => item.group !== 'non_specify')
                      .map((res, index) => (
                        <Text key={index}>
                          <Text style={styles.textSmall}>
                            {index > 0 ? ', ' : ''}
                            {res.group}:&nbsp;
                          </Text>
                          <Text style={styles.textSmall}>{res.value}</Text>
                        </Text>
                      ))}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.modalFooter}>
            <Button
              buttonStyle={styles.buttonStyle}
              title="Go to Registry"
              onPress={goToRegistry}
            />
          </View>
        </View>
      </Suspense>
    </Modalize>
  );
};

const styles = StyleSheet.create({
  handleStyle: {
    top: 26,
    backgroundColor: isWeb ? 'transparent' : '#D7CDF5',
    height: 3,
    width: 38,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    overflow: 'hidden',
    ...(isWeb
      ? {
          margin: 'auto',
          borderRadius: 8,
        }
      : {}),
  },
  buttonStyle: {
    width: 'auto',
  },
  modalBody: {
    paddingHorizontal: 20,
    paddingBottom: 16,
  },
  modalFooter: {
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  modalContainer: {
    width: isWeb ? 390 : '100%',
  },
  modalDismiss: {
    position: 'absolute',
    right: 16,
    top: 16,
  },
  modalHeader: {
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 18,
    position: 'relative',
    width: '100%',
  },
  text: {
    ...Font.figtreeMedium,
    fontSize: 14,
    lineHeight: 22,
  },
  textSmall: {
    ...Font.figtreeMedium,
    fontSize: 13,
    lineHeight: 22,
  },
  textContent: {
    ...Font.figtreeMedium,
    fontSize: 14,
    lineHeight: 24,
  },
  textHeader: {
    ...Font.figtreeMedium,
    fontSize: 16,
    lineHeight: 22,
  },
  iconRegistry: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 24,
    height: 24,
  },
  cardInfoRegistry: {
    backgroundColor: Colors.orange2,
    padding: 16,
    borderBottomLeftRadius: 8,
    borderTopRightRadius: 8,
    marginTop: 16,
  },
  separator: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey6,
    marginVertical: 16,
  },
  cardProductRegistry: {
    flex: 1,
    flexDirection: 'row',
    padding: 16,
    backgroundColor: '#FAF8FC',
    borderRadius: 8,
    marginVertical: 8,
  },
  productImage: {
    width: 64,
    height: 64,
    marginRight: 12,
    borderRadius: 8,
    overflow: 'hidden',
  },
  containerProductInfo: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
});

export default React.memo(ModalAddRegistry);
